<ng-container *ngIf="segment">
	<copo-metal-coating [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-metal-coating>
	<copo-organic-coating [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-organic-coating>
	<copo-roughness [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-roughness>
	<copo-surface-cleanliness [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-surface-cleanliness>
	<copo-chemical-surface-treatment [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-chemical-surface-treatment>
</ng-container>
